import React from 'react'
import './styles.scss'
import Button from '../buttons/Button'
import close from './../../images/close-white.svg'
import chartIco from './../../images/chart-ico.svg';
import arrowsIco from './../../images/arrows-ico.svg';
import plateIco from './../../images/plate-ico.svg';
import moneyIco from './../../images/money-ico.svg';
import lockIco from './../../images/lock-ico.svg';
import calendarIco from './../../images/calendar-blue-ico.svg';
import percentIco from './../../images/percent-ico.svg';
import orderIco from './../../images/order-ico.svg';
import fastIco from './../../images/fast-ico.svg';
import grenkeTablet from './../../images/people-tablet.jpg';


const ModalWhyGrenke = ( props ) => {
   
    return (
        <div className="static-modal">
            <div className="modal small">
                <div className="content why-grenke">
                    <div className="icons-wrap">
                        <img src={ close } alt="Zamknij" onClick={ () => props.closeModal() } />
                    </div>
                    <div className="col-small">
                        <div className="welcome">
                            <div className="image">
                                <img src={ grenkeTablet } alt=""/>
                            </div>
                            <div className="box">
                                Dlaczego <br/>
                                warto wybrać  <br/>
                                Grenke?
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="icons">
                            <div className="icon">
                                <img src={ fastIco } alt=""/>
                                <h2>Szybkość</h2>
                                <p>
                                    Prosty i szybki dostęp
                                    do nowoczesnych technologii. 
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ plateIco } alt=""/>
                                <h2>Wygoda</h2>
                                <p>
                                    Sprzęt i finansowanie w jednym miejscu online.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ arrowsIco } alt=""/>
                                <h2>Elastyczność</h2>
                                <p>
                                    Parametry umowy dopasowane do potrzeb firmy.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ percentIco } alt=""/>
                                <h2>Zarządzanie Kosztami</h2>
                                <p>
                                    Korzystny wpływ rat na obniżenie podatku dochodowego.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ calendarIco } alt=""/>
                                <h2>Łatwe planowanie</h2>
                                <p>
                                    Stałe, równe raty bez uzależnienia
                                    od WIBOR.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ moneyIco } alt=""/>
                                <h2>100% finansowania</h2>
                                <p>
                                    Zapłata za przedmiot bez angażowania środków własnych.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ chartIco } alt=""/>
                                <h2>Rozwój i płynność</h2>
                                <p>
                                    Uwolnienie zasobów firmy na inne sektory i wydatki w firmie.  
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ orderIco } alt=""/>
                                <h2>Konkurencyjność</h2>
                                <p>
                                    Stała optymalizacja rozwoju infrastruktury firmy.
                                </p>
                            </div>
                            <div className="icon">
                                <img src={ lockIco } alt=""/>
                                <h2>Bezpieczeństwo</h2>
                                <p>
                                    Stabilny i zaufany partner biznesowy. 
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalWhyGrenke;